"use client";

import { useEffect } from "react";
import {
  trackSessionStart,
  trackSessionEnd,
  trackPerformanceMetric,
} from "@/lib/analytics";

export function SessionTracker() {
  useEffect(() => {
    // Track session start
    trackSessionStart();

    // Track performance metrics
    if (typeof window !== "undefined" && "performance" in window) {
      // Track page load time
      window.addEventListener("load", () => {
        const navigation = performance.getEntriesByType(
          "navigation"
        )[0] as PerformanceNavigationTiming;
        if (navigation) {
          trackPerformanceMetric(
            "page_load_time",
            navigation.loadEventEnd - navigation.fetchStart
          );
          trackPerformanceMetric(
            "dom_content_loaded",
            navigation.domContentLoadedEventEnd - navigation.fetchStart
          );
          trackPerformanceMetric(
            "first_contentful_paint",
            navigation.loadEventEnd - navigation.fetchStart
          );
        }
      });

      // Track Core Web Vitals if available
      if ("web-vital" in window) {
        // This would require the web-vitals library, but we'll skip for now
        // import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';
      }
    }

    // Track session end on page unload
    const handleBeforeUnload = () => {
      trackSessionEnd();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Also track on visibility change (when user switches tabs)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        trackSessionEnd();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null; // This component doesn't render anything
}
